import "jsvectormap/dist/jsvectormap.min.css";
import "flatpickr/dist/flatpickr.min.css";
import "dropzone/dist/dropzone.css";
import "driver.js/dist/driver.css";



import Swal from 'sweetalert2';

import $ from 'jquery';
import 'select2/dist/js/select2.min.js';
import Alpine from "alpinejs";
import persist from "@alpinejs/persist";
import flatpickr from "flatpickr";
import Dropzone from "dropzone";
import { driver } from "driver.js";

// The DataTables stack (datatables.net + responsive + buttons, plus jszip
// and pdfmake for its Excel/PDF exports) used to be imported here. Its
// stylesheet was never bundled — only the JS — so every page it touched
// rendered unstyled wrapper markup, and all three pages using it have
// since moved to the plain list table. Dropping it removes ~3.7 MiB from
// the bundle, most of it pdfmake. If exports are ever wanted again,
// re-add the JS *and* install/import datatables.net-dt for the CSS.



window.Swal = Swal;
window.$ = $;
window.jQuery = $;
window.select2 = (typeof $ !== 'undefined' && $.fn && $.fn.select2) ? $.fn.select2 : null;
window.Select2 = window.select2;
window.Dropzone = Dropzone;
window.flatpickr = flatpickr;
window.driver = driver;


  // Configure Alpine before starting
Alpine.plugin(persist);
window.Alpine = Alpine;
 
  // Start Alpine.js
Alpine.start();




flatpickr(".datepicker", {
  mode: "range",
  static: true,
  monthSelectorType: "static",
  dateFormat: "M j, Y",
  defaultDate: [new Date().setDate(new Date().getDate() - 6), new Date()],
  prevArrow:
    '<svg class="stroke-current" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.25 6L9 12.25L15.25 18.5" stroke="" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  nextArrow:
    '<svg class="stroke-current" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.75 19L15 12.75L8.75 6.5" stroke="" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  onReady: (selectedDates, dateStr, instance) => {
    instance.element.value = dateStr.replace("to", "-");
    const customClass = instance.element.getAttribute("data-class");
    instance.calendarContainer.classList.add(customClass);
  },
  onChange: (selectedDates, dateStr, instance) => {
    instance.element.value = dateStr.replace("to", "-");
  },
});

// Get the current year
const year = document.getElementById("year");
if (year) {
  year.textContent = new Date().getFullYear();
}

// ─────────────────────────────────────────────────────────────────
// <c-modal> open/close helpers. Global so onclick="openModal('id')"
// works from any server-rendered template without importing anything.
// Kept as plain functions (not Alpine) so cotton components that don't
// use Alpine can still drive modals, and so there's one place to
// change behaviour in one place.
// ─────────────────────────────────────────────────────────────────
window.openModal = function (id) {
  const el = document.getElementById(id);
  if (!el) return;
  el.classList.remove("hidden");
  el.classList.add("flex");
  document.body.style.overflow = "hidden";
};

window.closeModal = function (id) {
  const el = document.getElementById(id);
  if (!el) return;
  el.classList.remove("flex");
  el.classList.add("hidden");
  document.body.style.overflow = "";
};

// Click outside a .modal-backdrop closes the modal.
document.addEventListener("click", function (event) {
  if (event.target.classList && event.target.classList.contains("modal-backdrop")) {
    window.closeModal(event.target.id);
  }
});

// Esc closes the topmost open modal.
document.addEventListener("keydown", function (event) {
  if (event.key !== "Escape") return;
  const open = Array.from(document.querySelectorAll(".modal-backdrop:not(.hidden)"));
  if (open.length === 0) return;
  window.closeModal(open[open.length - 1].id);
});






